import { useIntl } from 'react-intl'

import {
  EmptyState,
  Flex,
  Text,
  TEXT_VARIANT_STANDARD
} from 'mailup-web-components'

import { canUseMshop, mshopBuy } from 'Helpers/mshopHelpers'

const BaseConfigurationUpsell = () => {
  const intl = useIntl()

  const hasMshop = canUseMshop()

  return (
    <EmptyState
      data-mu-test='base-configuration-upsell'
      title={intl.formatMessage({
        id: 'Load.BaseConfigUpsell.EmptyStateTitle'
      })}
      description={intl.formatMessage({
        id: 'Load.BaseConfigUpsell.EmptyStateDescription'
      })}
      buttonText={
        hasMshop
          ? intl.formatMessage({
              id: 'Load.BaseConfigUpsell.EmptyStateCTA'
            })
          : undefined
      }
      onClickButton={mshopBuy}
    >
      {!hasMshop && (
        <Flex margin='16px 0 0 0'>
          <Text variant={TEXT_VARIANT_STANDARD} htmlElement='span'>
            {intl.formatMessage({
              id: 'Load.BaseConfigUpsell.EmptyStateAskBuy'
            })}
          </Text>
        </Flex>
      )}
    </EmptyState>
  )
}

export default BaseConfigurationUpsell
